import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/status`;

export interface RefreshFileCommandPayload {
  fileId: string;
}

export const refreshFileRequest = ({
  fileId,
}: RefreshFileCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.PUT },
});

async function refreshFileCommand(
  payload: RefreshFileCommandPayload,
): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(refreshFileRequest(payload));
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default refreshFileCommand;
